// Fixed animated multi-color aurora backdrop behind the whole site
export const AuroraBackground = () => {
  return (
    <div className="fixed inset-0 -z-10 overflow-hidden pointer-events-none" aria-hidden="true">
      <div className="absolute inset-0 bg-[#050510]" />

      {/* Colored aurora blobs */}
      <div className="absolute -top-40 -left-32 h-[46rem] w-[46rem] rounded-full bg-cobalt/25 blur-[130px] animate-blob-a" />
      <div className="absolute top-1/3 -right-40 h-[40rem] w-[40rem] rounded-full bg-violet/25 blur-[130px] animate-blob-b" />
      <div className="absolute bottom-0 left-1/4 h-[38rem] w-[38rem] rounded-full bg-teal/20 blur-[130px] animate-blob-a" />
      <div className="absolute top-2/3 right-1/4 h-[34rem] w-[34rem] rounded-full bg-magenta/18 blur-[140px] animate-blob-b" />

      {/* Fine grid */}
      <div
        className="absolute inset-0 opacity-[0.06]"
        style={{
          backgroundImage:
            "linear-gradient(rgba(255,255,255,0.6) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.6) 1px, transparent 1px)",
          backgroundSize: "64px 64px",
          maskImage: "radial-gradient(ellipse 80% 60% at 50% 30%, #000 40%, transparent 80%)",
          WebkitMaskImage: "radial-gradient(ellipse 80% 60% at 50% 30%, #000 40%, transparent 80%)",
        }}
      />
      {/* Darkening vignette for readability */}
      <div className="absolute inset-0 bg-[radial-gradient(ellipse_at_center,transparent_30%,rgba(5,5,16,0.55)_100%)]" />
    </div>
  );
};
